import { Box, Paper, Typography, Card } from "@mui/material";
import { Drawer } from "rsuite";
import JsonViewer from "../../common/components/JsonViewer";

export default function EventSchema({ open, onClose, schemaDetails }) {
  return (
    <Drawer open={open} onClose={onClose} size="xs">
      <Box style={{ border: "0px solid red" }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ padding: "0px", paddingRight: "0px", marginTop: "75px" }}
        ></Box>
        <Box
          style={{
            padding: "5px 5px 5px 22px",
            fontSize: "18px",
            color: "#3366ff",
            borderBottom: "1px solid #EAEDED",
          }}
        >
          Event Schema
        </Box>
        <Box
          style={{
            margin: "20px 5px 0px 15px",
            border: "0px solid red",
          }}
        >
          {schemaDetails && (
            <Box style={{ padding: "10px 15px", fontSize: "14px" }}>
              <strong>EventID: </strong> {schemaDetails.id}
              <br />
              <strong>Event Name:</strong> {schemaDetails.eventType}
              <br />
              <strong>Description:</strong> {schemaDetails.description}
              <br />
              {/* <strong>Payload version:</strong> {schemaDetails.payloadVersion}
              <br />
              <strong>Delivery priority:</strong>{" "}
              {schemaDetails.deliveryPriority}
              <br /> */}
              <strong>Document URL:</strong>{" "}
              {schemaDetails.docUrl ? schemaDetails.docUrl : "N/A"}
              <br />
              <Box sx={{ marginTop: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                  <b>
                    <u>Schema Example:</u>
                  </b>
                </Typography>

                {schemaDetails.schemaExample && (
                  <JsonViewer schemaExample={schemaDetails.schemaExample} />
                )}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  );
}
